import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-purchase-power-details",
  templateUrl: "./purchase-power-details.component.html",
  styleUrls: ["./purchase-power-details.component.scss"],
})
export class PurchasePowerDetailsComponent {
  @Input() purchasePower;
  @Input() blockingAmount;
  @Input() currencySelection;
  @Output() dismiss = new EventEmitter<boolean>();
  usdWithdraw: any;
  egpWithdraw: any;

  filteredBlockingAmount: any;

  constructor(public translate: TranslateService) {}

  close() {
    this.dismiss.emit(false);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.purchasePower?.currentValue) {
      this.purchasePower = changes.purchasePower.currentValue;

      this.usdWithdraw = 0;
      this.egpWithdraw = 0;
      var tempUsd = this.blockingAmount.filter((i) => i.curr == "USD");
      var tempEgp = this.blockingAmount.filter((i) => i.curr == "EGP");

      this.filteredBlockingAmount =
        this.blockingAmount.filter(
          (i) => i.curr == this.currencySelection
        )[0] ?? null;
      if (tempUsd.length > 0)
        this.usdWithdraw = tempUsd[0].AvailableBalanceForWithdrow;
      if (tempEgp.length > 0)
        this.egpWithdraw = tempEgp[0].AvailableBalanceForWithdrow;
    }

    var tempUsd = this.blockingAmount.filter((i) => i.curr == "USD");
    var tempEgp = this.blockingAmount.filter((i) => i.curr == "EGP");

    this.filteredBlockingAmount =
      this.blockingAmount.filter((i) => i.curr == this.currencySelection)[0] ??
      null;
    if (tempUsd.length > 0)
      this.usdWithdraw = tempUsd[0].AvailableBalanceForWithdrow;
    if (tempEgp.length > 0)
      this.egpWithdraw = tempEgp[0].AvailableBalanceForWithdrow;

    if (changes?.currencySelection?.currentValue) {
      this.currencySelection = changes.currencySelection.currentValue;
    }
  }
}
